export default {
   primary: '#da104e',
   secondary: '#424242',
   accent: '#82B1FF',
   error: '#FF3739',
   info: '#00D0BD',
   success: '#da104e',
   warning: '#FFB70F'
}